import React, { useEffect, useState } from 'react'
import "../css/TrafficFlow.css"
import { MainTitle } from '../components/MainTitle'
import * as imagesdata from '../imagesdata'
import { getMostRecentDetectedCar, getTrafficLight } from '../axios'
import ErrorPage from "./ErrorPage";
import useWebSocket from '../components/WebSocket'
import { Scene } from '../3d-components/Scene'
import { FaCube } from "react-icons/fa";
import { FaSquare } from "react-icons/fa";
const TrafficFlow = ({ setShowAppFooter, setShowAppNavbar }) => {

  const [detections, setDetections] = useState();
  const [trafficLightStatus, setTrafficLightStatus] = useState();
  const [trafficLightDuration, setTrafficLightDuration] = useState();
  const [trafficLightStatusIsFasila, setTrafficLightStatusIsFasila] = useState(false);
  const webSocketDetectionData = useWebSocket(process.env.REACT_APP_AI_URL + "/ws");
  const webSocketLightData = useWebSocket(process.env.REACT_APP_API_URL + "/ws");
  const [fontSize, setFontSize] = useState(0);
  const [found, setFound] = useState(true);
  const [loadingDetection, setLoadingDetection] = useState(true);
  const [is3D, setIs3D] = useState(false);
  const [loadingLight, setLoadingLight] = useState(true);
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth
      const newFontSize = Math.max(15, Math.min(25, (width / 25)));
      setFontSize(newFontSize)
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {

    getMostRecentDetectedCar()
      .then((res) => {
        setDetections(res.data);
        setLoadingDetection(false)
      })
      .catch((err) => {
        setShowAppFooter(false)
        setShowAppNavbar(true)
        setFound(false)
      });

    getTrafficLight()
      .then((res) => {
        setTrafficLightStatus(res.data.lightStatus);
        setTrafficLightDuration(res.data.duration);
        setLoadingLight(false)
      })
      .catch((err) => {
        setShowAppFooter(false)
        setShowAppNavbar(true)
        setFound(false)
      });
  }, []);

  useEffect(() => {
    if (webSocketLightData && webSocketLightData.lightStatus !== undefined) {
      setTrafficLightStatus(webSocketLightData.lightStatus);
      setTrafficLightDuration(webSocketLightData.duration);
    }
    else {
    }
  }, [webSocketLightData]);

  useEffect(() => {
    if (webSocketDetectionData && webSocketDetectionData.ust_detected_objects !== undefined) {
      setDetections(webSocketDetectionData);
    }
    else {
    }
  }, [webSocketDetectionData]);

  const ust_images = Array.from({ length: detections && detections.ust_detected_objects });
  const alt_images = Array.from({ length: detections && detections.alt_detected_objects });

  useEffect(() => {
    if (trafficLightStatus === "FASILALIKIRMIZI" || trafficLightStatus === "FASILALISARI") {
      setTrafficLightStatusIsFasila(true);
    } else {
      setTrafficLightStatusIsFasila(false);
    }
  }, [trafficLightStatus]);

  const getTrafficStatus = () => {
    if (trafficLightStatus === "KIRMIZI") return "Kırmızı";
    if (trafficLightStatus === "YESIL") return "Yeşil";
    if (trafficLightStatus === "FASILALIKIRMIZI") return "Fasılalı Kırmızı";
    if (trafficLightStatus === "FASILALISARI") return "Fasılalı Sarı";
    return "yanmıyor";
  };


  if (found == false) {
    document.title = "Sayfa Bulunamadı | Traflux";
    return <ErrorPage />
  }
  else {
    return (
      <div>
        <MainTitle headerImage={imagesdata.HeaderTrafficFlow} />
        <div className='main-text-bold-header' style={{ fontSize: `${fontSize - 2}px` }}>
          <h1>
            <span className='main-title-dark-text-outline'> Trafik </span> Akışı
          </h1>
        </div>
        <div className='main-text-header'>
          <h4>
            Aşağıdan trafik yoğunluğunu 2D veya 3D olarak görüntüleyebilir, "3D Görüntüle" ve "2D Görüntüle" butonları ile geçiş yapabilirsiniz. <br/>
            {is3D && (
              <span style={{ color: 'red', fontWeight: 'bold' }}>
                3D görüntü bazı cihazlarda yavaşlamaya neden olabilir. Lütfen performans sorunu yaşarsanız 2D modunu kullanın.
              </span>
            )}
          </h4>
        </div>
        {loadingDetection ? (
          // Başlangıçta yükleme ekranı
          <div style={{ display: "flex", justifyContent: "center" }}>
            <span style={{ marginTop: "180px", marginBottom: "300px" }} className="loader"></span>
          </div>
        ) : !is3D ? (
          // 2D Görüntü
          <div>
            <div className="traffic-flow-way-container">
              <div className="traffic-flow-way-body">
                <img className="traffic-flow-way-image" src={imagesdata.Way} />

                <div className="traffic-flow-way-cars-upper-body">
                  {ust_images.map(() => (
                    <div className="traffic-flow-way-cars">
                      <img src={imagesdata.Car} />
                    </div>
                  ))}
                </div>

                <div className="traffic-flow-way-cars-lower-body">
                  {alt_images.map(() => (
                    <div className="traffic-flow-way-cars">
                      <img src={imagesdata.Car} />
                    </div>
                  ))}
                </div>

                <div className="traffic-flow-way-light-upper-body">
                  {trafficLightStatus === "KIRMIZI" ? (
                    <img src={imagesdata.RedTrafficLight} />
                  ) : trafficLightStatus === "FASILALIKIRMIZI" ? (
                    <img src={imagesdata.RedTrafficLight} className="blinking-red-light" />
                  ) : trafficLightStatus === "FASILALISARI" ? (
                    <img src={imagesdata.YellowTrafficLight} className="blinking-yellow-light" />
                  ) : (
                    <img src={imagesdata.GreenTrafficLight} />
                  )}
                </div>

                <div className="traffic-flow-way-light-lower-body">
                  {trafficLightStatus === "KIRMIZI" ? (
                    <img src={imagesdata.RedTrafficLight} />
                  ) : trafficLightStatus === "FASILALIKIRMIZI" ? (
                    <img src={imagesdata.RedTrafficLight} className="blinking-red-light" />
                  ) : trafficLightStatus === "FASILALISARI" ? (
                    <img src={imagesdata.YellowTrafficLight} className="blinking-yellow-light" />
                  ) : (
                    <img src={imagesdata.GreenTrafficLight} />
                  )}
                </div>
              </div>
            </div>

            <div className='switch-to-3d-btn-container'>
              <button onClick={() => setIs3D(true)} className="switch-to-3d-btn">
                <FaCube className='icon' size={20} style={{ marginRight: "8px" }} />
                3D Görüntüle
              </button>
            </div>

            <div className="traffic-flow-way-status-body">
              Araçlara {trafficLightStatusIsFasila === false ? `${trafficLightDuration && trafficLightDuration} Saniye` : null} {getTrafficStatus()} Işık Yanıyor.
            </div>


          </div>
        ) : (
          // 3D Görüntü
          <>
            <Scene trafficLightStatus={trafficLightStatus} ust_images={ust_images} alt_images={alt_images} />
            <div className='switch-to-3d-btn-container'>
              <button onClick={() => setIs3D(false)} className="switch-to-3d-btn">
                <FaSquare className='icon' size={20} style={{ marginRight: "8px" }} />
                2D Görüntüle
              </button>
            </div>
            <div className="traffic-flow-way-status-body">
              Araçlara {trafficLightStatusIsFasila === false ? `${trafficLightDuration && trafficLightDuration} Saniye` : null} {getTrafficStatus()} Işık Yanıyor.
            </div>

          </>
        )}
      </div>
    )
  }
}

export default TrafficFlow

/*
{loadingDetection == true ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <span style={{ marginTop: "180px", marginBottom: "300px" }} class="loader"></span>
          </div>) : (
          <div>
            <div className="traffic-flow-way-container" >
              <div className="traffic-flow-way-body">

                <img className='traffic-flow-way-image' src={imagesdata.Way} />

                <div className='traffic-flow-way-cars-upper-body'>
                  {ust_images.map(() => (
                    <div className="traffic-flow-way-cars">
                      <img src={imagesdata.Car} />
                    </div>
                  ))}
                </div>

                <div className='traffic-flow-way-cars-lower-body'>
                  {alt_images.map(() => (
                    <div className="traffic-flow-way-cars">
                      <img src={imagesdata.Car} />
                    </div>
                  ))}
                </div>

                <div className='traffic-flow-way-light-upper-body'>
                  {trafficLightStatus == "KIRMIZI" ? (
                    <img src={imagesdata.RedTrafficLight} />
                  ) : trafficLightStatus == "FASILALIKIRMIZI" ? (
                    <img src={imagesdata.RedTrafficLight}
                      className="blinking-red-light" />
                  ) : trafficLightStatus == "FASILALISARI" ? (
                    <img src={imagesdata.YellowTrafficLight}
                      className="blinking-yellow-light" />
                  ) : (
                    <img src={imagesdata.GreenTrafficLight} />
                  )}
                </div>

                <div className='traffic-flow-way-light-lower-body'>
                  {trafficLightStatus == "KIRMIZI" ? (
                    <img src={imagesdata.RedTrafficLight} />
                  ) : trafficLightStatus == "FASILALIKIRMIZI" ? (
                    <img src={imagesdata.RedTrafficLight}
                      className="blinking-red-light" />
                  ) : trafficLightStatus == "FASILALISARI" ? (
                    <img src={imagesdata.YellowTrafficLight}
                      className="blinking-yellow-light" />
                  ) : (
                    <img src={imagesdata.GreenTrafficLight} />
                  )}
                </div>
              </div>
            </div>
            <div className='traffic-flow-way-status-body'>
              Araçlara {trafficLightStatusIsFasila == false ? `${trafficLightDuration && trafficLightDuration} Saniye` : null} {getTrafficStatus()} Işık Yanıyor.
            </div>
          </div>
        )}

        */